<div 
  class="custom-sidebar" 
  *ngIf="showPaymentMethodSidebar"
>
  <div class="sidebar-header">
    <span>
      <label class="text-4xl pb-1 text-theme-color opacity-80">{{ payment.PayServiceName }}</label><br>
      <small class="text-black-alpha-50">
        {{ payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet ? 'E-Wallet' : 'Bank' }}
      </small>
    </span>
    <button class="close-btn" (click)="closeSidebar()">✕</button>
  </div>
  <div class="flex-row pt-3">
    <div class="col-6 px-0 d-grid">
      <label class="text-3xl pb-1">
        <b>{{ payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet ? 'E-Wallet' : 'Bank'}}</b>
      </label>
      <label class="text-black-alpha-50">Payout Account Type</label>
    </div>
  </div>
  <div class="flex-row">
    <div class="col-6 px-0 d-grid">
      <label class="text-3xl pb-1"><b>{{payment.AccountName}}</b></label>
      <label class="text-black-alpha-50">Account Name</label>
    </div>
    <div class="col-6 px-0 d-grid">
      <label class="text-3xl pb-1"><b>{{ payment.AccountNumber }}</b></label>
      <label class="text-black-alpha-50">Account Number</label>
    </div>
  </div>
  <hr />
  <div class="flex-row">
    <div class="col-12 py-0 text-end">
      <button mat-flat-button color="primary" (click)="editPaymentMethod()">Edit</button>
    </div>
  </div>
</div>
